<template lang="html">
  <div class="widget-previewer">
    <div class="item-type">
      <div class="no-widget-selected" v-if="!hasItem">
        <h3>Select a widget from the left to see a preview.</h3>
      </div>
    </div>

    <div class="previewer-inner">
      <transition name="fade" mode="out-in">
        <div
          v-if="demoMode"
          @highlightField="highlightField"
          :is="listType.name"
          :currentListItem="demoItem"
          :items="listItems"
          demoMode>
        </div>
      </transition>

      <transition name="fade" mode="out-in">
        <div
          v-if="!demoMode"
          @highlightField="highlightField"
          :is="listType.name"
          :currentListItem="listItem"
          :items="sortedItems">
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

import HTMLPreviwer from '@/components/Previewers/HTMLPreviewer'
import Accordion from '@/components/Previewers/Accordion'
import MiniCarousel from '@/components/Previewers/MiniCarousel'
import Slideshow from '@/components/Previewers/Slideshow'
import PricingTable from '@/components/Previewers/PricingTable'
import TextContent from '@/components/Previewers/TextContent'
import TextImage from '@/components/Previewers/TextImage'
import Tabs from '@/components/Previewers/Tabs'
import BasicGallery from '@/components/Previewers/BasicGallery'
import ImageGrid from '@/components/Previewers/ImageGrid'
import FeatureBlocks from '@/components/Previewers/FeatureBlocks'
import ImageCards from '@/components/Previewers/ImageCards'
import TeamMembers from '@/components/Previewers/TeamMembers/TeamMembers'
import SimpleForm from '@/components/Previewers/SimpleForm'
import Reviews from '@/components/Previewers/Reviews'
import YoutubeVideos from '@/components/Previewers/YoutubeVideos/YoutubeVideos'
import Alert from '@/components/Previewers/Alert'
import SectionSeparator from '@/components/Previewers/SectionSeparator'
import LandingForm from '@/components/Previewers/LandingForm/LandingForm'
import ProductList from '@/components/Previewers/ProductList/ProductList'

export default {
  name: 'WidgetPreviewer',

  props: {
    demoMode: {
      type: Boolean,
      required: true,
      description: "When adding a content, widget preview should be demo mode. When editing content, it shouldn't"
    },

    listType: {
      type: Object,
      description: 'This is the type of list'
    },

    listItem: {
      type: Object,
      description: 'The current list item'
    },

    listItems: {
      type: Array,
      description: 'This is the json of all list items'
    }
  },

  computed: {
    sortedItems() {
      // This puts the current list item in an array by it's weight
      let array = this.listItems.filter(item => item.id !== this.listItem.id)

      array.splice(this.listItem.weight, 0, this.listItem)

      return array
    },

    demoItem() {
      return this.listItems[0]
    },

    hasItem() {
      return !!Object.keys(this.listType).length
    }
  },

  methods: {
    highlightField(field) {
      this.$emit('highlightField', field)
    }
  },

  components: {
    Sprite,
    'html-code': HTMLPreviwer,
    Accordion,
    MiniCarousel,
    Slideshow,
    PricingTable,
    TextContent,
    TextImage,
    Tabs,
    BasicGallery,
    ImageGrid,
    FeatureBlocks,
    ImageCards,
    TeamMembers,
    SimpleForm,
    Reviews,
    Alert,
    SectionSeparator,
    LandingForm,
    YoutubeVideos,
    ProductList
  }
}
</script>

<style lang="sass">
  @import '../stylesheets/base/variables'
  @import '../stylesheets/helpers/mixins'
  @import '../stylesheets/helpers/extends'

  .widget-previewer
    overflow: auto
    width: 100%
    position: relative
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.05)

    .previewer-inner
      padding: $gap-medium

    .item-type
      .sprite
        width: 30px
        height: 30px
        position: absolute
        top: $gap-small
        left: $gap-small
        opacity: 0.25

        @include themify($themes)
          fill: themed('color-secondary')

    .content-bg
      background: #fff
      box-shadow: $content-shadow
      padding: $gap-small

    table
      border-collapse: collapse
      table-layout: fixed
      width: 100%
      margin: 0
      overflow: hidden

      td
        width: auto!important
        border: 1px solid $color-border
        padding: $gap-small

        p
          &:last-child
            margin-bottom: 0

  .no-widget-selected
    margin-top: $gap-large
    text-align: center
    text-transform: uppercase

    @include themify($themes)
      color: themed('color-body')
</style>
